import { render } from "./AdditionalServices.vue?vue&type=template&id=5dac59f4"
import script from "./AdditionalServices.vue?vue&type=script&lang=js"
export * from "./AdditionalServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__